module.exports = __webpack_public_path__ + "img/linkInvalid.f22e5a1d.jpg";